import WeatherWidget from '../WeatherWidget';
import ProgressBar from '../ProgressBar';

export function OverviewTab({ 
  supporters, 
  hasSupported, 
  supporting, 
  showThanks, 
  handleSupport, 
  setActiveTab, 
  STAGES, 
  progressIndex, 
  progressDetails, 
  progressImages,
  posts,
  setSelectedPost,
  formatTime
}) {
  const latestNews = posts ? posts.slice(0, 2) : [];

  return (
    <div className="section-container">
      <WeatherWidget />
      
      {/* Current Progress Preview */}
      <div className="section-card cursor-pointer hover:shadow-lg transition-shadow" onClick={() => {
        setActiveTab("progress");
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }}>
        <div className="flex items-center justify-between mb-4">
          <h3 className="section-subtitle">Current Progress</h3>
          <span className="text-secondary/70 hover:text-secondary text-sm font-medium">View Details →</span>
        </div>
        <div className="progress-header">
          <h4 className="text-base font-semibold text-white">TVBA Project Progress</h4>
          <div className="progress-supporters">
            <div className="supporters-count">
              <span className="supporters-number">{supporters}</span>
              {supporters === 1 ? 'supporter' : 'supporters'}
            </div>
            <button
              className={`btn-primary px-4 py-2 text-sm ${hasSupported ? 'opacity-60 cursor-not-allowed' : ''}`}
              onClick={(e) => {
                e.stopPropagation();
                handleSupport();
              }}
              disabled={hasSupported || supporting}
            >
              {hasSupported ? 'Supported' : (supporting ? 'Supporting…' : 'Support')}
            </button>
            {showThanks && (
              <span className="success-badge">Thank you for supporting!</span>
            )}
          </div>
        </div>
        <ProgressBar
          stages={STAGES}
          currentIndex={progressIndex}
          onChangeIndex={undefined}
          details={progressDetails}
          images={progressImages}
          interactive={false}
          maskCurrent={false}
          showPercent={false}
        />
      </div>

      {/* Latest News Preview */}
      <div className="section-card cursor-pointer hover:shadow-lg transition-shadow" onClick={() => {
        setActiveTab("news");
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }}>
        <div className="flex items-center justify-between mb-4">
          <h3 className="section-subtitle">Latest News</h3>
          <span className="text-secondary/70 hover:text-secondary text-sm font-medium">View All →</span>
        </div>
        <div className="news-grid-preview">
          {latestNews.map(post => (
            <div 
              key={post.id} 
              className="news-card"
              onClick={(e) => {
                e.stopPropagation();
                setSelectedPost(post);
              }}
            >
              {post.image && (
                <img 
                  src={post.image} 
                  alt={post.title} 
                  className="news-image"
                  onError={(e) => {
                    e.currentTarget.style.display = 'none';
                  }}
                />
              )}
              <div className="news-content">
                <h4 className="news-title">{post.title}</h4>
                <p className="news-excerpt">
                  {post.content?.slice(0, 100)}
                  {post.content?.length > 100 ? '...' : ''}
                </p>
                <div className="news-meta">
                  <small className="news-date">
                    {formatTime(post.time)}
                  </small>
                </div>
              </div>
            </div>
          ))}
        </div>
        {posts.length > 2 && (
          <div className="text-center mt-4">
            <span className="text-sm text-white/50">Showing 2 of {posts.length} posts</span>
          </div>
        )}
      </div>
    </div>
  );
}
